import { Injectable } from '@angular/core';
import {environment} from "../../../../environments/environment";
import {HttpClient, HttpHeaders, HttpParams} from "@angular/common/http";
import {AuthenticationService} from "../../../services/authentication.service";
import {catchError, map} from "rxjs/operators";
import {filter, Observable, of} from "rxjs";
import {ProjectRequestDto} from "../models/project-request.dto";

@Injectable({
  providedIn: 'root'
})
export class ProjectTeamOverviewService {
  public baseUrl = environment.baseUrl + '/';

  constructor(private http: HttpClient, private auth: AuthenticationService) { }

  private getProjectHeaders(projectUuid = '') {
    if (projectUuid !== '') {
      return {
        headers: new HttpHeaders({
          // @ts-ignore
          'X-Workspace': localStorage.getItem('WORKSPACE_UUID'),
          'X-Project': projectUuid
        })
      };
    } else {
      return {
        headers: new HttpHeaders({
          // @ts-ignore
          'X-Workspace': localStorage.getItem('WORKSPACE_UUID'),
        })
      };
    }

  }

  private buildParams(filters: any): HttpParams {
    return Object.entries(filters)
      .filter(([_, value]) =>
        value !== null &&
        value !== undefined &&
        value !== '')
      .reduce(
        (params, [key, value]) => params.set(key, String(value)), new HttpParams()
      );
  }

  loadProjects(projectRequestDto: ProjectRequestDto): Observable<any> {
    const options = this.getProjectHeaders(projectRequestDto.projectUuid);
    let body = projectRequestDto.filters;
    let params = this.buildParams(projectRequestDto.params);

    return this.http.post<any>(this.baseUrl + 'projects-overview', body, {...options, ...(params && {params})})
      .pipe(
        map(res => res),
        catchError((err: any) => {
          console.log('project-check-in-reminder: '+JSON.stringify(err));
          return of({error: err});
        })
      );
  }

  getIndicatorInterval() {
    const options = this.getProjectHeaders();
    return this.http.get<any>(this.baseUrl + 'indicator-intervals', options)
      .pipe(
        map(res => {
            return res._embedded.indicatorIntervals;
          },
          (err: any) => {
            return err;
          }
        )
      );
  }
}
